import * as types from './mutation-types'

const mutation = {
  [types.DISPOSITIONS_GET_ALL](state, dispositions) {
    state.resolutions = dispositions
  },
  [types.DISPOSITIONS_GET_ACTIVE](state, dispositions) {
    state.activeDispositions = dispositions
  },
  [types.DISPOSITION_TYPES_GET_ALL](state, dispositionTypes) {
    state.dispositionTypes = dispositionTypes
  },
  [types.FOLLOWUPRESULTTYPES_GET_ACTIVE](state, followupResultTypes) {
    state.activefollowupResultTypes = followupResultTypes
  },
  [types.SET_SELECTED_RESOLUTION](state, newValue) {
    state.selectedResolution = newValue
  },
  [types.SET_SELECTED_TOPIC](state, newValue) {
    state.selected_topic = newValue
  },
  [types.ADD_NEW_RESOLUTION](state, r) {
    state.resolutions.push(r)
  },
  [types.UPDATE_RESOLUTION](state, r) {
    
  },
  [types.SAVE_TOPIC](state, t) {
    console.log(t)
    //create
    if (t.id === 0)
    {
      let newid = state.topics[state.topics.length -1].id ++
      t.id = newid;
      state.topics.push( code)
    }
    else {
      //update
      state.topics = [
        ...state.topics.filter(element => element.id !== t.id),
        t
      ]
    }
  }
}

export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/dispositions/mutations.js